import {
  EmptyBlock,
  InlineList,
  InlineListItem,
} from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import ObservationItem from '../../ObservationItem/ObservationItem'
import { ViewProps } from './types'

export const GridView = ({
  children,
  observations,
  onItemClick,
  tagDecorator,
  menuContextualItems,
  emptyMessage,
}: ViewProps) => {
  const { t } = useTranslation()

  return observations ? (
    <>
      <InlineList>
        {observations.map((observation) => (
          <InlineListItem key={observation.id}>
            {children ? (
              children(observation)
            ) : (
              <ObservationItem
                observation={observation}
                onClick={onItemClick}
                tagDecorator={tagDecorator}
                menuContextualItems={menuContextualItems}
              />
            )}
          </InlineListItem>
        ))}
      </InlineList>
      {observations.length === 0 && (
        <EmptyBlock
          message={
            emptyMessage ||
            t("There's nothing here. Try uploading a new image.")
          }
        />
      )}
    </>
  ) : (
    <div />
  )
}
